/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetCompositionsDetailEditsQueryResponse, GetCompositionsDetailEditsPathParams } from "../models/GetCompositionsDetailEdits";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getCompositionsDetailEdits } from "../axios/getCompositionsDetailEdits";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getCompositionsDetailEditsQueryKey = (id: GetCompositionsDetailEditsPathParams["id"]) => ["web-app-bff-api", { url: '/compositions/:id/edits', params: {id:id} }] as const

export type GetCompositionsDetailEditsQueryKey = ReturnType<typeof getCompositionsDetailEditsQueryKey>

export function getCompositionsDetailEditsQueryOptions(id: GetCompositionsDetailEditsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getCompositionsDetailEditsQueryKey(id)
        return queryOptions<GetCompositionsDetailEditsQueryResponse, ResponseErrorConfig<Error>, GetCompositionsDetailEditsQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getCompositionsDetailEdits(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List video-editor edits for a composition
 * {@link /compositions/:id/edits}
 */
export function useGetCompositionsDetailEdits<TData = GetCompositionsDetailEditsQueryResponse, TQueryData = GetCompositionsDetailEditsQueryResponse, TQueryKey extends QueryKey = GetCompositionsDetailEditsQueryKey>(id: GetCompositionsDetailEditsPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<GetCompositionsDetailEditsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getCompositionsDetailEditsQueryKey(id)
         

         const query = useQuery({
          ...getCompositionsDetailEditsQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}